import { apiConfig } from '../api-config';

export interface ActCreateParamsV {
  territoryId: string;
  tokenKey: string;
  dtAutovistory: string;
}

export const actCreateCurrent = async (params: ActCreateParamsV) => apiConfig.post('api/ActDocument/create-vigent', params).then((resp) => resp.data);
